<template lang="pug">
#v-app.container
  v-header
  v-scoreboard
</template>

<script>
import VHeader from '@/components/Header.vue'
import VScoreboard from '@/components/Scoreboard.vue'

export default {
  name: 'App',
  components: {
    VHeader,
    VScoreboard,
  },
}
</script>

<style lang="sass" scoped>
@import "~@/mixin.sass"

#v-app
  background-color: white
  min-height: 100%
  min-width: 960px
</style>
